import { render, staticRenderFns } from "./DraftListItem.vue?vue&type=template&id=35c6bbb4&scoped=true&"
import script from "./DraftListItem.vue?vue&type=script&lang=js&"
export * from "./DraftListItem.vue?vue&type=script&lang=js&"
import style0 from "./DraftListItem.vue?vue&type=style&index=0&id=35c6bbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6bbb4",
  null
  
)

export default component.exports